export const RUOLI = {
  admin: { label: "Admin", cls: "bg-slate-800 text-slate-100 border-slate-800" },
  project_manager: { label: "Project Manager", cls: "bg-purple-50 text-purple-800 border-purple-200" },
  legale: { label: "Legale", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  commercialista: { label: "Commercialista", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  ingegnere: { label: "Ingegnere", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  marketing: { label: "Marketing", cls: "bg-pink-50 text-pink-800 border-pink-200" },
  commerciale: { label: "Commerciale", cls: "bg-cyan-50 text-cyan-800 border-cyan-200" },
};

const U = (id) => `https://images.unsplash.com/photo-${id}?w=1200&q=80&fm=jpg&fit=crop`;
export const IMG_SETTORI = {
  "stabilimenti-balneari": "/img/forte-dei-marmi.jpg",
  "turismo-ricettivita": U("1566073771259-6a8506099945"),
  "energia-fotovoltaico": U("1509391366360-2e959784a276"),
  "digitale-transizione-5-0": U("1518770660439-4636190af475"),
  "mobilita-sostenibile": U("1558618666-fcd25c85cd64"),
  "ristrutturazione-sicurezza": U("1504307651254-35680f356dfd"),
  "commercio-artigianato": U("1556740738-b6a63e27c4df"),
  "agricoltura-agroalimentare": U("1500382017468-9049fed747ef"),
  "sostenibilita-esg": U("1542601906990-b4d3fb778b09"),
  "industria-manifatturiero": U("1581091226825-a6a2a5aee158"),
  "farmaceutico-chimico": U("1532187863486-abf9dbad1b69"),
  "tessile-moda": U("1489987707025-afc232f7ea0f"),
  "logistica-trasporti": U("1586528116311-ad8dd3c8310d"),
  "servizi-professionali": U("1454165804606-c3d57bc86b40"),
  "nuove-imprese-startup": U("1559136555-9303baea8ebd"),
};
export const IMG = {
  beach: "/img/forte-dei-marmi.jpg",
  pontile: "/img/forte-dei-marmi-pontile.jpg",
  growth: U("1543269865-cbf427effbad"),
  solar: U("1509391366360-2e959784a276"),
  roles: {
    admin: U("1519389950473-47ba0277781c"),
    project_manager: U("1552664730-d307ca884978"),
    legale: U("1589829545856-d10d557cf95f"),
    commercialista: U("1554224155-6726b3ff858f"),
    ingegnere: U("1504307651254-35680f356dfd"),
    marketing: U("1557804506-669a67965ba0"),
    commerciale: U("1521791136064-7986c2920216"),
  },
};

export const STATO_PRATICA = {
  in_lavorazione: { label: "In lavorazione", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  in_revisione: { label: "In revisione", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  inviata: { label: "Inviata", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  archiviata: { label: "Archiviata", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const STATO_FASE = {
  da_iniziare: { label: "Da iniziare", cls: "bg-slate-100 text-slate-600" },
  in_corso: { label: "In corso", cls: "bg-blue-100 text-blue-800" },
  completata: { label: "Completata", cls: "bg-emerald-100 text-emerald-800" },
};

export const STATO_TASK = {
  da_fare: { label: "Da fare", cls: "bg-slate-100 text-slate-700" },
  in_corso: { label: "In corso", cls: "bg-blue-100 text-blue-800" },
  completato: { label: "Completato", cls: "bg-emerald-100 text-emerald-800" },
};

export const STATO_DOC = {
  mancante: { label: "Mancante", cls: "bg-red-50 text-red-700 border-red-200" },
  caricato: { label: "Caricato", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  verificato: { label: "Verificato", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatEuro = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const daysTo = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Math.ceil((d - new Date()) / 86400000);
};
